import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "row"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.rowTargets[this.rowTargets.length - 1].querySelector("select, input")?.focus()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-rows-target='row']")
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField && row.dataset.persisted === "true") {
      destroyField.value = "1"
      row.hidden = true
      return
    }
    row.remove()
  }
}
